// const state = { 
//   num: 1,
//   reqUrlArr: []
// }
// const getters = {
//   num: state => state.num,
//   reqUrlArr: state => state.reqUrlArr
// };
// // mutations
// const mutations = {
//   SET_NUM (state, num) {
//     state.num = num++; 
//     if((state.num -1) > 5) {
//       console.log('此页面接口请求数量超出最大请求范围（暂定每个页面最多请求5个接口），请您及时修改业务逻辑');
//     }
//   },
//   SET_TABLEURL (state, reqUrlArr) {
//     if(Array.isArray(reqUrlArr)) {
//       state.reqUrlArr = reqUrlArr
//     }
//   },
  
// }
// const actions = {
//   SET_NUM({ commit }, num) {
//       commit('SET_NUM', num);
//   },
//   SET_TABLEURL({ commit }, reqUrl) {
//       commit('SET_TABLEURL', reqUrl);
//   },
// };

// export default {
//   state,
//   getters,
//   mutations,
//   actions
// }


const state = {
  reqTotalTime: 0,
	routerName:'',  // 当前路由
  routerUrl:'',  // 当前url
  asyncMethods:[],  // 页面访问的数据接口
  startTime: '访问时间：'+
  (new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours())+':'+
  (new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes())+':'+
  (new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds())
      // 开始进入页面时间
}

const actions = {
	notifyBackend (store,newRouter) {
        const { commit, state } = store;
        let param = {
            'routerName': newRouter.routerName,  // 页面名
            'routerUrl': newRouter.routerUrl,  // 页面url
            'asyncMethods': state.asyncMethods,  // 页面访问数据集合
            'time':new Date().getTime()-state.startTime, // 页面访问时间
        }
        // console.log('======================',param)
        commit('reset', newRouter);  // 初始化数据
    },
    addAsyncMethods(context, method){
        context.commit('addAsyncMethods', method);  // 每请求一次数据  异步向集合添加一次 
    }
}
const mutations = {
	updataState(state, data){  // 公共更新state  状态方法
    for (let key in data) {
      state[key] = data[key]
    }
    setTimeout(() => {
      if(state.asyncMethods.length > 5) {
        console.error(`此页面接口请求数量(${state.asyncMethods.length}个接口请求)已超出最大请求范国（暂定每个页面最多请求5个接口），请您及时修改业务逻辑`);
      }
      let num = 0
      state.asyncMethods.map(v => {
        num += v.time
      })
      state.reqTotalTime = num
      console.log('当前页面请求数据', state);
    },1800)
  },
  addAsyncMethods (state, method={}) {  // 更改数据请求集合
    state.asyncMethods.push(method);
  },
  reset(state,newRouter){  // 初始化
    state.routerName=newRouter.routerName;
    state.routerUrl=newRouter.routerUrl;
    state.asyncMethods=[];
    // state.startTime=new Date().getTime();
    state.startTime=
    '访问时间：'+
    (new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours())+':'+
    (new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes())+':'+
    (new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds())
  }
}

export default {
  state,
  mutations,
  actions
}
